import { noop } from 'lodash-es';
import React from 'react';
import { LINK_ICON } from '@marvelapp/theme';
import { Box, Flex, Icon, IconButton, PinTR, Tooltip } from '@marvelapp/ui';
import { CopyToClipboard } from '@marvelapp/ui-internal';
import Minus from '../icons/Minus';
import Plus from '../icons/Plus';
export default function Zoom(_a) {
    var _b = _a.decrementZoom, decrementZoom = _b === void 0 ? noop : _b, _c = _a.incrementZoom, incrementZoom = _c === void 0 ? noop : _c, zoom = _a.zoom, fitZoom = _a.fitZoom;
    var copyIcon = (React.createElement(Icon, { display: "block", height: 24, paths: LINK_ICON, width: 24 }));
    var urlToCopy = window.location.href;
    return (React.createElement(PinTR, { display: "flex", padding: 10 },
        React.createElement(Flex, { alignItems: "center", bg: "rgba(249,250,252,.94)", borderRadius: 2, boxShadow: "button.toolbar", py: 1 },
            React.createElement(Box, { px: 1 },
                React.createElement(IconButton, { bg: "transparent", hoverBg: "transparent", onClick: decrementZoom },
                    React.createElement(Minus, null))),
            React.createElement(Box, { borderLeft: "1px solid", borderRight: "1px solid", 
                // eslint-disable-next-line
                borderColor: "smoke", px: 1 },
                React.createElement(IconButton, { bg: "transparent", fontSize: 2, fontWeight: 500, hoverBg: "transparent", onClick: fitZoom },
                    zoom,
                    "%")),
            React.createElement(Box, { px: 1 },
                React.createElement(IconButton, { bg: "transparent", hoverBg: "transparent", onClick: incrementZoom },
                    React.createElement(Plus, null)))),
        React.createElement(Box, { marginLeft: 2 },
            React.createElement(Tooltip, { content: "Copy handoff link", position: "bottom" },
                React.createElement(CopyToClipboard, { alignItems: "center", borderRadius: 2, btnText: copyIcon, display: "flex", height: 34, iconColor: "slate", justifyContent: "center", kind: "toolbar", px: 0, text: urlToCopy, transitionType: "icon", width: 34 })))));
}
